<template>
    <section class="order-saving">
        <span class="order-saving__title">적립금 사용</span>
        <div class="order-saving__contents">
            <div class="order-saving__block">
                <span class="order-saving__subtitle">사용할 적립금</span>
                <div class="order-saving__form">
                    <div class="input input--red"><input v-model="point" type="number" @input="input(false)" /><span class="currency-unit">원</span></div>
                    <button class="button button--mouse" type="button" @click="input(true)"><span>전액사용</span></button>
                    <span class="left-text">보유 적립금액 : {{ me.point.format() }}원</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        value: { type: Number, default: 0 },
        me: { type: Object, default: null },
        maxAmount: { type: Number, default: 0 },
    },
    data() {
        return {
            point: +this.$props.value || 0,
        };
    },
    methods: {
        input(isMax) {
            const {
                maxAmount,
                me: { point },
            } = this;
            if (maxAmount < this.point) this.point = maxAmount;
            if (isMax) this.point = maxAmount < point ? maxAmount : point;
            this.$emit("input", +this.point);
        },
    },
    watch: {
        value() {
            this.point = this.value;
        },
        maxAmount() {
            const { maxAmount } = this;
            if (maxAmount < this.point) {
                this.point = maxAmount;
                this.$emit("input", +maxAmount);
            }
        },
    },
};
</script>
